"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalParameterValue = void 0;
const vue_1 = require("vue");
const TranslateMixin_1 = require("./TranslateMixin");
const constants_1 = require("../constants");
const GlobalParameter_1 = require("../GlobalParameter");
exports.GlobalParameterValue = vue_1.default.component('global-parameter-value', {
    props: {
        param: {
            type: String,
        },
        value: {
            type: Number,
        },
        automa: {
            type: Boolean,
        },
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    methods: {
        isMax: function () {
            switch (this.param) {
                case GlobalParameter_1.GlobalParameter.TEMPERATURE:
                    return this.value === constants_1.MAX_TEMPERATURE;
                case GlobalParameter_1.GlobalParameter.OXYGEN:
                    return this.value === constants_1.MAX_OXYGEN_LEVEL;
                case GlobalParameter_1.GlobalParameter.OCEANS:
                    if (this.automa)
                        return this.value === constants_1.MAX_OCEAN_TILES_AUTOMA;
                    return this.value === constants_1.MAX_OCEAN_TILES;
                case GlobalParameter_1.GlobalParameter.VENUS:
                    return this.value === constants_1.MAX_VENUS_SCALE;
                default:
                    return false;
            }
        },
        getIconClass: function () {
            switch (this.param) {
                case GlobalParameter_1.GlobalParameter.TEMPERATURE:
                    return 'preferences_temperature-tile';
                case GlobalParameter_1.GlobalParameter.OXYGEN:
                    return 'preferences_oxygen-tile';
                case GlobalParameter_1.GlobalParameter.OCEANS:
                    return 'preferences_ocean-tile';
                case GlobalParameter_1.GlobalParameter.VENUS:
                    return 'preferences_venus-tile';
                default:
                    return '';
            }
        },
    },
    template: `
<div>
  <div :class="getIconClass()"></div>
  <div class="preferences_global_params_value">
    <div v-if="isMax()">
      <img src="/assets/misc/checkmark.png" class="preferences_checkmark" :alt="$t('Completed!')">
    </div>
    <div v-else>
      {{this.value}}
    </div>
  </div>
</div>
  `,
});
//# sourceMappingURL=GlobalParameterValue.js.map